import Icon from '../components/Icon.vue'

Icon.register({
  'book-open': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M542.2 32.1C487.4 35.2 378.5 46.5 311.3 87.6 306.6 90.5 304 95.5 304 100.8V464.7C304 476.2 316.6 483.5 327.3 478.2 396.4 443.4 496.5 433.9 546 431.3 562.9 430.4 576 416.8 576 400.6V62.8C576 45 560.6 31 542.2 32.1zM264.7 87.6C197.5 46.5 88.6 35.2 33.8 32.1 15.4 31 0 45 0 62.8V400.6C0 416.8 13.1 430.4 30 431.3 79.5 433.9 179.6 443.4 248.8 478.2 259.4 483.6 272 476.3 272 464.8V100.6C272 95.3 269.4 90.5 264.7 87.6z'
      }
    ]
  }
})
